import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a removeChild error
    if (
      error &&
      error.message &&
      (error.message.includes('removeChild') ||
       error.message.includes('NotFoundError') ||
       error.message.includes('The node to be removed is not a child of this node'))
    ) {
      // Ignore removeChild errors - they're cosmetic
      return { hasError: false };
    }
    
    // For other errors, update state
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a removeChild error
    if (
      error &&
      error.message &&
      (error.message.includes('removeChild') ||
       error.message.includes('NotFoundError') ||
       error.message.includes('The node to be removed is not a child of this node'))
    ) {
      // Silently ignore these errors
      console.log('Suppressed removeChild error (non-critical)');
      return;
    }
    
    // Log other errors
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md">
            <h1 className="text-2xl font-bold text-red-600 mb-4">Algo salió mal</h1>
            <p className="text-gray-700 mb-4">
              Lo sentimos, ha ocurrido un error inesperado. Por favor, recarga la página.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
            >
              Recargar Página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
